import { makeApiRequest } from '@/src/lib/api-request'
import { useToken } from '@/src/store/token-store'
import { Video } from '@/src/types/video'
import { useInfiniteQuery } from '@tanstack/react-query'

interface SubscriptionVideoResponse {
  videos: Video[]
  offset: number
}

export const useSubscriptionVideosQuery = () => {
  const { accessToken } = useToken()
  return useInfiniteQuery({
    initialPageParam: { offset: 0 },
    queryKey: ['subscription-videos', accessToken],
    queryFn: async ({ pageParam }): Promise<SubscriptionVideoResponse> => {
      const newOffset = pageParam.offset
      
        const dataProps = {
          limit: 10,
          offset: newOffset,
        }
        const response = await makeApiRequest({
          method: 'POST',
          url: '/Subscribe/getAllSubscribedVideos',
          isAuthenticated: true,
          data: dataProps,
          fallbackError: 'Error while fetching subcription videos',
          isV3Api: true
        })
        const videos: Video[] = response.response.data
        return { videos, offset: newOffset }
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.videos.length === 0) return undefined
      const newOffset = lastPage.offset + 10
      return { offset: newOffset }
    },
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    enabled: !!accessToken
  })
}
